import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

type IntlImportFeesColumnProps = {
  fulfillmentId: string;
};

const IntlImportFeesColumn = ({ fulfillmentId }: IntlImportFeesColumnProps) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelFulfillment } = fulfillment;

  if (!labelFulfillment?.intlImportFees) {
    return '';
  }

  const { value, code } = labelFulfillment.intlImportFees;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

type ColumnData =
  | {
      id: string;
    }
  | null
  | undefined;

export const intlImportFees = {
  getMessageDescriptor: () => messages.importFees,
  id: 'intlImportFees',
  render: (data: ColumnData) => {
    if (!data) {
      return '';
    }
    return <IntlImportFeesColumn fulfillmentId={data.id} />;
  },
};
